import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NewsItem = {
  id: number;
  title: string;
  content: string;
  picture: string;
  type: string;
  link?: string;
  status: number;
};

interface NewsState {
  items: NewsItem[];
  loading: boolean;
  error: string | null;
}

const initialState: NewsState = {
  items: [],
  loading: true,
  error: null,
};

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    setNews: (state, action: PayloadAction<NewsItem[]>) => {
      state.items = action.payload;
    },
    deleteNews: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    addNews: (state, action: PayloadAction<NewsItem>) => {
      state.items.unshift(action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setNews, deleteNews, addNews, setLoading, setError } = newsSlice.actions;
export default newsSlice.reducer;
